
<div class="container">
    <div class="mt-5 d-flex align-items-center">
        <img routerLink="/quiz-completed" class="c-pointer" src="assets/icons/back.svg" alt="">
    </div>
    <div *ngIf="result" class="my-3 pt-3 d-flex align-items-center justify-content-center">
        <table class="mytable pb-5">
            <thead>
              <tr>
                <th>{{'No.'| translate}}</th>
                <th>{{'Team' | translate}}</th>
                <th>{{'Team code' | translate}}</th>
                <th>{{'Questions completed' | translate}}</th>
                <th>{{'Score' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let team of result; let i = index">
                <td class="text-24-600-116 text-c2">{{ i + 1 }}</td>
                <td class="text-24-600-133 text-c4">{{ team?.name  || 'name'}}</td>
                <td class="text-24-500-116 text-c4">{{ team?.team_code || "7568" }}</td>
                <td>
                    <div class="progress">
                        <div class="progress-bar" role="progressbar" [style.width.%]="team?.completed_percentage"
                        aria-valuenow="12" aria-valuemin="0" aria-valuemax="100">
                        </div>
                    </div>
                </td>
                <td class="text-36-600-88 text-c4">
                    <span>{{team.score}}</span>
                </td>
              </tr>
            </tbody>
          </table>
    </div>
</div>
